import { render } from "./about.vue?vue&type=template&id=0fb5d5bd&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=0fb5d5bd&scoped=true&lang=css"

import exportComponent from "D:\\Project\\Lmm\\gw_lmm\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_6285803b7cea55eb83ef6d11bd88d191\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb5d5bd"]])

export default __exports__